$(document).ready(function () {
    // Bulk actions
    $(".bulk-actions").on('click', 'a', function (e) {
        const form = $('form#main-form');

        e.preventDefault();

        if (confirm('Are you sure? This action cannot be undone.')) {
            form.attr('action', $(this).attr('href'));
            form.submit();
        }
    });

    // Hide flash mesage
    if ($('.alert.disapear').length > 0) {
        setTimeout(function () {
            $('.alert').slideUp();
        }, 2000);
    }

    // Tooltips
    $('[data-toggle="tooltip"]').tooltip();


    //	Check-all
    $("input.check-all").on('change', function () {
        let scope = $(this).data('scope');

        if (!scope) return;

        let status = $(this).prop('checked');

        $('input[type=checkbox]' + scope).prop('checked', status);
    });
});
